import {Card, Checkbox, Flex, InputNumber, Modal, Space, Switch} from "antd";
import {useState} from "react";
import {useAppDispatch, useAppSelector} from "../../../../../../feature/tools";
import {genres} from "../../../../../../feature/Draft";
import {addGenre, removeGenre, setLines, setPerson, togglePlot} from "../../../../../../feature/project/draftSlice";

export const PlotSetup = (
    props: {
        onCancel: () => void
        onSave: () => void
    }
) => {
    const draft = useAppSelector(state => state.draftSlice.draft)
    const dispatch = useAppDispatch()
    const [hasChanges, setHasChanges] = useState(true)

    return (
        <Modal
            maskClosable={false}
            open={true}
            destroyOnClose={true}
            title={`Plot Settings`}
            okText={'Save'}
            okButtonProps={{disabled: !hasChanges}}
            onCancel={() => props.onCancel()}
            onOk={() => props.onSave()
            }
            width={800}
        >
            <Flex gap={10}>
                <Space direction={'vertical'} style={{width: 800}}>
                    <Card title={'Genres'}>
                        <Flex
                            vertical={true}
                            wrap={'wrap'}
                            gap={10}
                            style={{height: 320}}
                        >
                            {genres.sort((a, b) => a.russian < b.russian ? -1 : 1).map(genre =>
                                <Checkbox
                                    style={{width: 200}}
                                    key={genre.english}
                                    checked={draft.properties.genre.includes(genre.english)}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            dispatch(addGenre({genre: genre.english}))
                                        } else {
                                            dispatch(removeGenre({genre: genre.english}))
                                        }
                                    }
                                    }>
                                    {genre.russian}
                                </Checkbox>
                            )}
                        </Flex>
                    </Card>
                    <Flex gap={10}>
                        <Card title={'Plot'}>
                            <Space>
                                <Switch
                                    title={'Linear'}
                                    value={draft.properties.linear}
                                    onChange={(e) => {
                                        dispatch(togglePlot())
                                        dispatch(setLines({lines: e ? 1 : draft.properties.lines}))
                                    }
                                    }
                                />
                                Linear

                                    <InputNumber
                                        min={1}
                                        max={50}
                                        disabled={draft.properties.linear}
                                        value={draft.properties.lines}
                                        onChange={(e) => dispatch(setLines({lines: e ?? 1}))}/>
                            </Space>
                        </Card>
                        <Card title={'Narration'}>
                            <Space>
                                <Switch
                                    title={'First person'}
                                    value={draft.properties.person == 1}
                                    onChange={(e) => dispatch(setPerson({person: e ? 1 : 3}))}
                                />
                                First-person
                            </Space>
                        </Card>
                    </Flex>
                </Space>
            </Flex>
        </Modal>
    )
}